<template>
  <DropDownInput
    :canFilter="true"
    :dropdownTitle="$t('calculator.profit-trend-form.select-fiat.title')"
    @filter="handleFilter"
    @open="dropDownHandler"
  >
    <template #value>
      <slot />
    </template>
    <template #input-side>
      {{ selectedFiat.code }}
    </template>
    <template #default="{hide}">
      <ExchangeLoading v-if="availableFiatCurrencies.loading" />
      <div v-else>
        <FiatCurrency
          v-for="item in filteredList"
          :key="item.code"
          :selected="selectedFiat === item.code"
          :currency="item.code"
          :icon="item.code.toUpperCase()"
          :label="item.name"
          @click.native="selectHandler(item, hide)"
        />
      </div>
    </template>
  </DropDownInput>
</template>

<script setup lang="ts">
import DropDownInput from "@kano/components/ProfitCalculator/Form/DropDownInput.vue";
import { ProfitCalculatorCurrency } from "@kano/types/profit-calculator";
import { useMemoize } from "@vueuse/core";
import { useSimpleList } from "@kano/composables";
import SeoClient from "@kano/services/clients/seo-client";

import { computed, ref } from "vue";
import ExchangeLoading from "@kano/components/ExchangeFormV2/ExchangeLoading.vue";
import FiatCurrency from "@kano/components/ExchangeFormV2/FiatCurrency.vue";

const props = defineProps<{
  value: ProfitCalculatorCurrency,
}>();

const emit = defineEmits<{
  (event: 'input', value: ProfitCalculatorCurrency): void,
}>();

const filterString = ref<string>('');
const selectedFiat = ref<ProfitCalculatorCurrency>(props.value);
const getAvailableCryptoCurrencies = useMemoize(() => SeoClient.getAvailableFiatCurrencies());
const { state: availableFiatCurrencies, fetch: fetchAvailableFiatCurrencies } = useSimpleList({
  loading: true,
  list: () => getAvailableCryptoCurrencies(),
});

const filteredList = computed(() => availableFiatCurrencies.items.filter((item) => {
  return item.name.toLowerCase().includes(filterString.value.toLowerCase()) ||
    item.code.toLowerCase().includes(filterString.value.toLowerCase());
}));

const selectHandler = (option, closePopupHandler) => {
  selectedFiat.value = option;
  emit('input', option);
  emit('close');
  closePopupHandler();
};

const handleFilter = (filter) => {
  filterString.value = filter;
}

const dropDownHandler = async () => {
  await fetchAvailableFiatCurrencies();
}
</script>
